import { zDappVersion } from '@/general/src/dapp/shared.js'
import { z } from 'zod'

export const zCreateUpgradePostForAdminEndpointInput = z.object({
  title: z.string().min(1),
  publishedAt: z.coerce.date(),
  desktopappVersion: zDappVersion,
  contentMd: z.string().min(1),
})
